module.exports = __webpack_public_path__ + "fonts/Mulish-Italic.ttf?c25d531c7ccb1f5d3714a64ea790348b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mulish-Italic.ttf
// module id = 320
// module chunks = 0